import { useState, useEffect } from 'react'
import { useDiamondData } from 'context/diamondFilterContext'
import { DiamondDataContextType } from 'types/diamondFilter.types'
import {
  TableHeader,
  TableListView,
  TableGridView,
  TableComparisonView,
} from '@components/yadav/ui'
import { IDiamond } from 'types/diamond.types'
import NoDiamondsMatched from '../NoDiamondsMatched'
import useLocalStorage from 'hooks/useLocalStorage'
import { useDiamondFilterAPI } from 'context/diamondFilterContext'
import { DiamondFilterAPIContextType } from 'types/diamondFilter.types'

const DiamondsTable = () => {
  const { loadingDiamonds, diamondData, setLoadingDiamonds } =
    useDiamondData() as DiamondDataContextType
  const [activeRadio, setActiveRadio] = useState(1)
  const [itemsToCompare, setItemsToCompare] = useLocalStorage<
    Partial<IDiamond>[]
  >('diamond-comparison', [])
  const { onSortUpdate } = useDiamondFilterAPI() as DiamondFilterAPIContextType
  const onSort = (sort: string, direction: string, option: string) => {
    onSortUpdate(sort, direction, option)
  }
  useEffect(() => {
    try {
      const item = window.localStorage.getItem('diamond-comparison')
      if (item) {
        const diamondsToCompare = JSON.parse(item) as IDiamond[]
        setItemsToCompare(diamondsToCompare)
      }
    } catch (error) {
      // If read from storage fails, the initial state is used instead.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoadingDiamonds(true)
    if (diamondData) {
      setLoadingDiamonds(false)
    }
  }, [diamondData, setLoadingDiamonds])

  if (diamondData === null) {
    return (
      <div className="flex justify-center items-center h-44">
        <div className="flex justify-center items-center min-h-[280px] w-full sm:min-w-[400px]">
          <div className="flex items-center">
            <div className="w-2 h-2 rounded-full bg-accent-9 mr-1 animate-pulse"></div>
            <div className="w-2 h-2 rounded-full bg-accent-9 mr-1 animate-pulse"></div>
            <div className="w-2 h-2 rounded-full bg-accent-9 animate-pulse"></div>
          </div>
        </div>
      </div>
    )
  }
  if (loadingDiamonds) {
    return (
      <div className="flex justify-center items-center h-44">
        <div className="flex justify-center items-center min-h-[280px] w-full sm:min-w-[400px]">
          <div className="flex items-center">
            <div className="w-2 h-2 rounded-full bg-accent-9 mr-1 animate-pulse"></div>
            <div className="w-2 h-2 rounded-full bg-accent-9 mr-1 animate-pulse"></div>
            <div className="w-2 h-2 rounded-full bg-accent-9 animate-pulse"></div>
          </div>
        </div>
      </div>
    )
  } else {
    if (diamondData && diamondData.length === 0) {
      return (
        <>
          <TableHeader
            data={diamondData}
            loading={loadingDiamonds}
            itemsToCompare={itemsToCompare}
            activeRadio={activeRadio}
            setActiveRadio={setActiveRadio}
          />
          <NoDiamondsMatched />
        </>
      )
    } else {
      return (
        <>
          <TableHeader
            data={diamondData}
            loading={loadingDiamonds}
            itemsToCompare={itemsToCompare}
            activeRadio={activeRadio}
            setActiveRadio={setActiveRadio}
          />
          {activeRadio === 1 ? (
            <div className="block">
              <TableListView
                onSort={onSort}
                data={diamondData}
                loading={loadingDiamonds}
                itemsToCompare={itemsToCompare}
                setItemsToCompare={setItemsToCompare}
              />
            </div>
          ) : activeRadio === 2 ? (
            <div className="hidden md:block">
              <TableGridView
                data={diamondData}
                loading={loadingDiamonds}
                itemsToCompare={itemsToCompare}
                setItemsToCompare={setItemsToCompare}
              />
            </div>
          ) : (
            <div className="hidden md:block">
              <TableComparisonView
                itemsToCompare={itemsToCompare}
                setItemsToCompare={setItemsToCompare}
                setActiveRadio={setActiveRadio}
              />
            </div>
          )}
        </>
      )
    }
  }
}

export default DiamondsTable
